/**
* oknoway
* http://www.oknoway.com
*
* Copyright (c) 2015 Nate Bedortha @ OK/No Way
*/

 ( function( window, undefined ) {
  'use strict';


 } )( this );
